import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  Skeleton,
} from '@shigo-ui/ui';

import { useBusyDialogGuard } from '../../../../../hooks/useBusyDialogGuard';
import { dashboardT } from '../../../../../lib/messages';
import type { A2vLivePreviewResponse } from '../../model';
import { resolveCdnUrl } from './resolveCdnUrl';

interface NetworkTemplateLivePreviewDialogProps {
  loading: boolean;
  error: boolean;
  response?: A2vLivePreviewResponse | undefined;
  cdnUrl: string;
  onClose: () => void;
}

export function NetworkTemplateLivePreviewDialog({
  loading,
  error,
  response,
  cdnUrl,
  onClose,
}: NetworkTemplateLivePreviewDialogProps) {
  const guard = useBusyDialogGuard(loading, onClose);
  const videoPath = response?.[0]?.convertedVideos[0]?.videoPath;
  let content = (
    <div className="text-muted-foreground flex aspect-video items-center justify-center text-sm">
      {dashboardT('a2v.networkTemplate.livePreviewUnavailable')}
    </div>
  );
  if (loading) {
    content = <Skeleton className="aspect-video w-full rounded-md" />;
  } else if (error) {
    content = (
      <div className="text-destructive flex aspect-video items-center justify-center text-sm">
        {dashboardT('a2v.networkTemplate.livePreviewError')}
      </div>
    );
  } else if (videoPath) {
    content = (
      <video
        className="aspect-video w-full rounded-md bg-black"
        src={resolveCdnUrl(cdnUrl, videoPath)}
        controls
        autoPlay
        muted
        playsInline
      />
    );
  }
  return (
    <Dialog open onOpenChange={guard.onOpenChange}>
      <DialogContent
        className="max-w-[860px]"
        onEscapeKeyDown={guard.onDismissInteraction}
        onPointerDownOutside={guard.onDismissInteraction}
      >
        <DialogHeader>
          <DialogTitle>{dashboardT('a2v.networkTemplate.livePreview')}</DialogTitle>
          <DialogDescription>
            {dashboardT('a2v.networkTemplate.livePreviewDescription')}
          </DialogDescription>
        </DialogHeader>
        {content}
      </DialogContent>
    </Dialog>
  );
}
